// /topic/system-events 에서 DATA.FX_RATES.* / DATA.COMMODITY_PRICES.* 만 필터 구독.
// 권위: ARCH_DASHBOARD.md v1.8 §4.15 + §6.3 (ADR-DASH-04 — 전용 토픽 미신설).

import { useEffect } from 'react';
import type { IMessage } from '@stomp/stompjs';
import { subscribe } from './useWebSocket';

export interface MarketDataEvent {
  event_code: string;
  event_id?: string;
  occurred_at?: string;
  severity?: string;
  payload?: Record<string, unknown>;
}

function normalize(raw: unknown): MarketDataEvent | null {
  if (!raw || typeof raw !== 'object') return null;
  const obj = raw as Record<string, unknown>;
  const code = (obj.event_code ?? obj.eventCode) as string | undefined;
  if (!code || typeof code !== 'string') return null;
  return {
    event_code: code,
    event_id: (obj.event_id ?? obj.eventId) as string | undefined,
    occurred_at: (obj.occurred_at ?? obj.occurredAt) as string | undefined,
    severity: obj.severity as string | undefined,
    payload: (obj.payload ?? undefined) as Record<string, unknown> | undefined,
  };
}

const PREFIXES = ['DATA.FX_RATES.', 'DATA.COMMODITY_PRICES.'];

export function useMarketDataEvents(handler: (ev: MarketDataEvent) => void): void {
  useEffect(() => {
    const unsub = subscribe('/topic/system-events', (msg: IMessage) => {
      let parsed: unknown;
      try {
        parsed = JSON.parse(msg.body);
      } catch {
        return;
      }
      const ev = normalize(parsed);
      if (!ev) return;
      if (!PREFIXES.some((p) => ev.event_code.startsWith(p))) return;
      try {
        handler(ev);
      } catch {
        /* 무시 */
      }
    });
    return unsub;
  }, [handler]);
}
